import { useEffect } from "react";
import { useSelector } from "react-redux";

import { useAppDispatch } from "src/redux/hooks";

import { queueReport } from "./globalReportSlice";
import reportDefinitions from "./reportDefinitions";
import { ReportSource } from "./types";
import type { ReportParams } from "./types";

type UseReportOptions = {
  /**
   * Filename base (without date or extension). The report slice always appends
   * `-{yyyy-MM-dd}`; collisions append `-vN`. Defaults to `reportName`.
   */
  filename?: string;
};

const useReport = (
  reportName: keyof ReturnType<typeof reportDefinitions>,
  [resource, params]: [resource: string, params: ReportParams],
  { filename }: UseReportOptions = {}
) => {
  const dispatch = useAppDispatch();
  const requestReport = useSelector(
    (state: any) => state.globalReports.requestReport
  );

  useEffect(() => {
    if (requestReport === reportName) {
      dispatch(
        queueReport({
          reportName,
          resource,
          params,
          source: ReportSource.JSON_API,
          filename,
        })
      );
    }
  }, [requestReport, reportName, resource, params, filename, dispatch]);
};

export default useReport;
